import { searchSessionStarted, startSearchSession } from '../actions/publicActions';
import setNextSearchQueryId from '../mutators/setNextSearchQueryId';
import setSearchSessionGuid from '../mutators/setSearchSessionGuid';
import { getStore } from '../store/store';
import importLazyImports from '../utils/importLazyImports';
import { getGuid } from 'owa-guid';
import { lazySubstrateSearchInitOperation } from 'owa-search-service';
import { orchestrator } from 'satcheljs';
export default orchestrator(startSearchSession, function (actionMessage) {
    var actionSource = actionMessage.actionSource, shouldStartSearch = actionMessage.shouldStartSearch;
    var store = getStore();
    // Throw if user is already in a search session.
    if (store.searchSessionGuid) {
        throw new Error('searchSessionGuid should not be set when starting a search session.');
    }
    // Set IDs in the store.
    setSearchSessionGuid(getGuid());
    setNextSearchQueryId(getGuid());
    // Make init request if search box is 3S-powered.
    if (getStore().isUsing3S) {
        lazySubstrateSearchInitOperation.import().then(function (substrateSearchInitOperation) {
            substrateSearchInitOperation(store.nextSearchQueryId);
        });
    }
    /**
     * After common "start session" work is done, dispatch event to notify
     * consumer that search session has been started.
     */
    searchSessionStarted(actionSource, shouldStartSearch);
    /**
     * Since search session has started, we can kick off imports for other
     * actions, mutators, and orchestrators required for search to speed up
     * user experience.
     */
    importLazyImports();
});
//# sourceMappingURL=startSearchSessionOrchestrator.js.map